import { createRouter, createWebHistory } from 'vue-router'

import HomePage from '../pages/Home.vue'
import ClimatePage from '../pages/Climate.vue'
import DownloadsPage from '../pages/Downloads.vue'
import MyCentrePage from '../pages/MyCentre.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
  {
    path: '/climate',
    name: 'climate',
    component: ClimatePage,
  },
  {
    path: '/downloads',
    name: 'downloads',
    component: DownloadsPage,
  },
  {
    path: '/my-centre',
    name: 'my-centre',
    component: MyCentrePage,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
